import { Kinds } from "constants/product-collection";
import { PlanMetricLabelColumn } from "./plan-metric-label-column";
import { PlanMetricDoorColumn } from "./plan-metric-door-column";
import { PinnedRowOtherColumn } from "../pinned-row-other-column";
import { isDoorColumn } from "helpers/door-collection";

export const getColumnComponent = (kind: Kinds, fieldName: string): React.FunctionComponent<any> => {
    if (kind === Kinds.IMAGE_URL) {
        return PlanMetricLabelColumn;
    } else if (
        (kind === Kinds.DOOR_BULK_QUANTITY && isDoorColumn(fieldName)) ||
        kind === Kinds.TOTAL_ALLOCATION_DIMENSIONS
    ) {
        return PlanMetricDoorColumn;
    } else {
        return PinnedRowOtherColumn;
    }
};
